import { useNavigate } from 'react-router-dom';
import LegalLinks from '@/components/LegalLinks';
import {
  AppButton,
  AppButtonRow,
  AppCard,
  AppCardBody,
  AppCardHeader,
  AppPage,
  AppPageIntro,
  AppSectionHeader,
  PRICING_PAGE_CONTENT,
} from '../../ui-foundation';

export default function PricingPage() {
  const navigate = useNavigate();

  return (
    <AppPage className="animate-fade-in">
      <AppPageIntro title={PRICING_PAGE_CONTENT.title} subtitle={PRICING_PAGE_CONTENT.subtitle} />

      <AppCard>
        <AppCardHeader>
          <AppSectionHeader
            title={PRICING_PAGE_CONTENT.accessTitle}
            subtitle={PRICING_PAGE_CONTENT.accessSubtitle}
          />
        </AppCardHeader>
        <AppCardBody>
          <div className="space-y-4">
            <div className="space-y-2">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-primary">{PRICING_PAGE_CONTENT.accessKicker}</p>
              <p className="text-5xl font-bold leading-none text-foreground sm:text-6xl">{PRICING_PAGE_CONTENT.accessPrice}</p>
              <p className="text-sm leading-relaxed text-muted-foreground">{PRICING_PAGE_CONTENT.accessBody}</p>
            </div>

            <AppButtonRow>
              <AppButton size="sm" onPress={() => navigate('/auth')}>
                Join free beta
              </AppButton>
              <AppButton size="sm" tone="outline" onPress={() => navigate('/')}>
                Back to landing
              </AppButton>
            </AppButtonRow>

            <p className="text-sm text-muted-foreground">{PRICING_PAGE_CONTENT.accessFooter}</p>
          </div>
        </AppCardBody>
      </AppCard>

      <AppCard>
        <AppCardHeader>
          <AppSectionHeader title={PRICING_PAGE_CONTENT.includedTitle} subtitle={PRICING_PAGE_CONTENT.includedSubtitle} />
        </AppCardHeader>
        <AppCardBody>
          <div className="grid gap-4 md:grid-cols-2">
            {PRICING_PAGE_CONTENT.included.map((item) => (
              <AppCard key={item.title} backgroundColor="$background" px="$sm" py="$sm">
                <div className="flex items-start gap-3">
                  <span className="mt-1 text-primary">✓</span>
                  <div>
                    <h3 className="text-base font-semibold text-foreground">{item.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
                  </div>
                </div>
              </AppCard>
            ))}
          </div>
        </AppCardBody>
      </AppCard>

      <AppCard>
        <AppCardHeader>
          <AppSectionHeader title={PRICING_PAGE_CONTENT.faqTitle} subtitle={PRICING_PAGE_CONTENT.faqSubtitle} />
        </AppCardHeader>
        <AppCardBody>
          <div className="space-y-3">
            {PRICING_PAGE_CONTENT.faqs.map((item) => (
              <AppCard key={item.question} backgroundColor="$background" px="$sm" py="$sm">
                <details>
                  <summary className="cursor-pointer list-none text-sm font-semibold text-foreground">
                    {item.question}
                  </summary>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{item.answer}</p>
                </details>
              </AppCard>
            ))}
          </div>
        </AppCardBody>
      </AppCard>

      <AppCard>
        <AppCardHeader>
          <AppSectionHeader title={PRICING_PAGE_CONTENT.joinTitle} />
        </AppCardHeader>
        <AppCardBody>
          <div className="space-y-4">
            <p className="text-sm leading-relaxed text-muted-foreground">{PRICING_PAGE_CONTENT.joinBody}</p>
            <AppButtonRow>
              <AppButton size="sm" onPress={() => navigate('/auth')}>
                Join free beta
              </AppButton>
              <AppButton size="sm" tone="outline" onPress={() => navigate('/')}>
                Back to landing
              </AppButton>
            </AppButtonRow>
          </div>
        </AppCardBody>
      </AppCard>

      <div className="pt-2">
        <LegalLinks tone="public" />
      </div>
    </AppPage>
  );
}
